import { render, staticRenderFns } from "./TermSensitive.vue?vue&type=template&id=53006734&scoped=true&"
import script from "./TermSensitive.vue?vue&type=script&lang=js&"
export * from "./TermSensitive.vue?vue&type=script&lang=js&"
import style0 from "./TermSensitive.vue?vue&type=style&index=0&id=53006734&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53006734",
  null
  
)

export default component.exports